import { hasRoleAccessToRoute } from '@/config/rolePermissions';

export const hasRoleAccess = (routeName, userRole) => {
  return hasRoleAccessToRoute(routeName, userRole);
};

export const getRoutesForRole = (userRole) => {
  const { getRoutesForRole: getRoutes } = require('@/config/rolePermissions');
  return getRoutes(userRole);
};
